import { Variant } from 'framer-motion'

const springTransition = {
   duration: 0.3,
   type: 'spring',
   stiffness: 100,
}

const tweenTransition = {
   duration: 0.3,
   type: 'tween',
}

const tweenPageAnimation = {
   duration: 0.3,
   ease: 'circOut',
   power: 3,
   type: 'tween',
}

const variants = {
   default: {} as Variant,
   shake: {
      x: [0, 10, -10, 10, -10, 10, -10, 0],
      transition: {
         ease: 'circInOut',
         power: 2,
      },
   } as Variant,

   fadeIn: {
      opacity: 1,
      transition: springTransition,
   } as Variant,

   fadeOut: {
      opacity: 0,
      transition: springTransition,
   } as Variant,

   reveal: {
      opacity: 1,
      y: 0,
      transition: springTransition,
   } as Variant,

   disappearUp: {
      opacity: 0,
      y: -100,
      transition: tweenTransition,
   } as Variant,

   disappearDown: {
      opacity: 0,
      y: 100,
      transition: tweenTransition,
   } as Variant,
   collapse: {
      height: 0,
      transition: tweenTransition,
   } as Variant,
   collapseWithOpacity: {
      height: 0,
      scale: 0.95,
      opacity: 0,
      transition: tweenTransition,
   } as Variant,
   expand: {
      height: 'auto',
      scale: 1,
      opacity: 1,
      transition: tweenTransition,
   } as Variant,

   collapseInHeigh: {
      height: 0,
      transition: {
         duration: 1,
         type: 'spring',
         stiffness: 100,
         damping: 20,
      },
      transitionEnd: {
         display: 'none',
      },
   } as Variant,

   // -------------
   // Page variants
   // -------------
   pageAnimate: {
      opacity: 1,
      transition: tweenPageAnimation,
   } as Variant,
   pageInitial: {
      opacity: 0,
      transition: tweenPageAnimation,
   } as Variant,
   pageAnimateFast: {
      opacity: 1,
      transition: {
         duration: 0.15,
         ease: 'circOut',
         power: 3,
         type: 'tween',
      },
   } as Variant,
   pageInitialFast: {
      opacity: 0,
      transition: {
         duration: 0.15,
         ease: 'circOut',
         power: 3,
         type: 'tween',
      },
   } as Variant,
}

export type variantsType = keyof typeof variants

export default variants
